import { render, staticRenderFns } from "./OtherDetail.vue?vue&type=template&id=2f26694b&scoped=true&"
import script from "./OtherDetail.vue?vue&type=script&lang=js&"
export * from "./OtherDetail.vue?vue&type=script&lang=js&"
import style0 from "./OtherDetail.vue?vue&type=style&index=0&id=2f26694b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f26694b",
  null
  
)

export default component.exports